import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks";
import { ICartItemProps } from "../../cartInterface";
import { Checkbox, Select } from "@/template/components";
import { updateCartItem } from "@/redux/slices/user/thunks/updateCartItem";
import { getCart } from "@/redux/slices/user/thunks/getCart";

const DomainNameServer = ({ item, reviewOrder }: Partial<ICartItemProps>) => {
  const dispatch = useTypedDispatch();
  const customNameservers = useTypedSelector(
    (state) => state.user.cart.ns_groups
  );
  const keys = Object.keys(customNameservers);

  const nameServerUuid = item.extra_details.nameserver_group_uuid;

  const keepNameServers = item.extra_details.keep_nameservers;

  const options = [
    {
      label: "Yay.com NS",
      key: "yay",
    },
  ];
  keys.forEach((key) => {
    options.push({
      label: customNameservers[key],
      key: key,
    });
  });

  return (
    <>
      <div
        style={{
          gridColumn: "1 / span 2",
        }}
      >
        <Select
          fullWidth
          disabled={keepNameServers || item.loading || reviewOrder}
          loading={item.loading}
          selected={keepNameServers ? "yay" : nameServerUuid}
          onChange={(val) => {
            dispatch(
              updateCartItem({
                id: item.id,
                slug: `/svc/cart/domain-transfer/${item.id}`,
                data: {
                  nameserver_group_uuid: val,
                },
              })
            ).then(() => dispatch(getCart()));
          }}
          options={options}
          popupProps={{
            width: 200,
            placement: "bottom-end",
          }}
        />
      </div>
      <Checkbox
        checked={keepNameServers}
        disabled={item.loading || reviewOrder}
        label="Keep Name Servers"
        blob={{
          size: "md",
        }}
        onChange={(val) => {
          if (item.loading) return;
          dispatch(
            updateCartItem({
              id: item.id,
              slug: `/svc/cart/domain-transfer/${item.id}`,
              data: {
                nameserver_group_uuid: val ? null : "yay",
              },
            })
          ).then(() => dispatch(getCart()));
        }}
      />
    </>
  );
};

export default DomainNameServer;
